<div class="container-fluid">
  <app-pagetitle
    title="Machine Reports"
    [breadcrumbItems]="breadCrumbItems"
  ></app-pagetitle>
  <div class="row">
    <div class="col-xl-12">
      <div class="row">
        <div class="col-md-2">
          <div class="form-group">
            <label>Department</label>
            <select
              class="form-control custom-select"
              [(ngModel)]="selectedDepartment"
              name="departmentName"
              id="departmentName"
              (ngModelChange)="select_Department()"
            >
              <option
                *ngFor="let dept of departmentData"
                [ngValue]="dept.departmentName"
              >
                {{ dept.departmentName }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group">
            <label>Machine</label>
            <select
              class="form-control custom-select"
              [(ngModel)]="deviceName"
              name="deviceName"
              id="device"
              (ngModelChange)="onDeviceChange($event)"
            >
              <option
                *ngFor="let device of deviceListData"
                [ngValue]="device.deviceName"
              >
                {{ device.deviceName }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group">
            <label>From Date</label>
            <input
              class="form-control"
              type="date"
              [(ngModel)]="fromDate"
                (change)="onFromDateChange()" 
              [min]="mindate"
              [max]="maxdate"
            />
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group">
            <label>To Date</label>
            <input
              class="form-control"
              type="date"
              [(ngModel)]="toDate"
              [min]="fromDate"   
               [max]="maxdate"
            />
          </div>
        </div>
        <div class="col-md-1">
          <button
            style="margin-top: 1.8rem; width: 100%"
            class="btn btn-success btn-rounded"
            type="button"
            [disabled]="isData"
            (click)="getData()"
          >
            Submit
          </button>
        </div>

        <div class="col-md-1" *ngIf="showTable && tableData.length > 0">
          <button
            style="margin-top: 1.8rem; width: 100%"
            class="btn btn-primary btn-rounded"
            type="button"
            (click)="openModal(templatepdf, 'downloadpdfcsv', 'Export')"
          >
            Export
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div *ngIf="!showTable" class="text-center text-muted">
            Please wait, we are fetching data.
          </div>

          <div
            *ngIf="showTable && tableData.length > 0"
            class="table-responsive table-container"
          >
            <table
              class="table table-striped table-bordered table-centered datatable dt-responsive nowrap mb-0"
            >
              <thead class="thead-dark">
                <tr>
                  <th>Date</th>
                  <th>Department</th>
                  <th>Machine Name</th>
                  <th>Production (hrs)</th>
                  <th>Qty Planned</th>
                  <th *ngIf="!hasPin2">Qty Produced</th>
                  <th *ngIf="hasPin2">Partcount 1</th>
                  <th *ngIf="hasPin2">Partcount 2</th>
                  <th>Running (hrs)</th>
                  <th>Idle (hrs)</th>
                  <th *ngIf="hasBreakdown">Breakdown (hrs)</th>
                  <th *ngIf="hasInterlock">Interlock (hrs)</th>
                  <th>Off / Power Outage (hrs)</th>
                  <th>Downtime (hrs)</th>
                  <th *ngIf="hasAnalog1">Analog 1</th>
                  <th *ngIf="hasAnalog2">Analog 2</th>
                  <th>Availability(%)</th>
                  <th>Performance(%)</th>
                  <th>Quality(%)</th>
                  <th>Oee(%)</th>
                  <th>Total Energy (kWh)</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let data of tableData
                      | slice
                        : (currentPage - 1) * itemsPerPage
                        : currentPage * itemsPerPage
                  "
                >
                  <td>{{ data.date ? data.date : "--" }}</td>
                  <td>{{ data.departmentName ? data.departmentName : "--" }}</td>
                  <td>{{ data.deviceName ? data.deviceName : "--" }}</td>
                  <td>{{ data.productionHour ? data.productionHour : "00:00:00" }}</td>
                  <td>{{ data.quantityPlanned ? data.quantityPlanned : 0 }}</td>

                  <!-- Qty Produced / Part counts -->
                  <td *ngIf="!hasPin2">{{ data.pin1Count ? data.pin1Count : 0 }}</td>
                  <td *ngIf="hasPin2">{{ data.pin1Count ? data.pin1Count : 0 }}</td>
                  <td *ngIf="hasPin2">{{ data.pin2Count ? data.pin2Count : "NA" }}</td>

                  <td>{{ data.runningHour ? data.runningHour : "00:00:00" }}</td>
                  <td>{{ data.idleHour ? data.idleHour : "00:00:00" }}</td>

                  <!-- Optional columns -->
                  <td *ngIf="hasBreakdown">{{ data.breakdownHour ? data.breakdownHour : "00:00:00" }}</td>
                  <td *ngIf="hasInterlock">{{ data.interlockHour ? data.interlockHour : "00:00:00" }}</td>

                  <td>{{ data.offHour ? data.offHour : "00:00:00" }}</td>
                  <td>{{ data.downTime ? data.downTime : "00:00:00" }}</td>

                  <!-- Analog columns — shown only if at least one row has that analog -->
                  <td *ngIf="hasAnalog1">
                    <ng-container *ngIf="data.analogData?.analog1; else naAnalog1">
                      Name: {{ data.analog1Name || 0 }} <br />
                      Min: {{ data.analog1Min || 0 }} <br />
                      Max: {{ data.analog1Max || 0 }} <br />
                      Avg: {{ data.analog1Avg || 0 }}
                    </ng-container>
                    <ng-template #naAnalog1>NA</ng-template>
                  </td>
                  <td *ngIf="hasAnalog2">
                    <ng-container *ngIf="data.analogData?.analog2; else naAnalog2">
                      Name: {{ data.analog2Name || 0 }} <br />
                      Min: {{ data.analog2Min || 0 }} <br />
                      Max: {{ data.analog2Max || 0 }} <br />
                      Avg: {{ data.analog2Avg || 0 }}
                    </ng-container>
                    <ng-template #naAnalog2>NA</ng-template>
                  </td>

                  <td>{{ data.avaliablity || 0 }}</td>
                  <td>{{ data.performance || 0 }}</td>
                  <td>{{ data.quality || 0 }}</td>
                  <td>{{ data.oee || 0 }}</td>
                  <td>{{ data.totalEnergy || 0 }}</td>
                </tr>
              </tbody>
            </table>

            <div class="col-md-6" *ngIf="tableData?.length > itemsPerPage">
              <ngb-pagination
                class="pagination-rounded"
                [collectionSize]="tableData?.length"
                [pageSize]="itemsPerPage"
                [(page)]="currentPage"
                [maxSize]="1"
                [rotate]="true"
                [ellipses]="false"
                [boundaryLinks]="true"
                (pageChange)="onPageChange($event)"
              >
              </ngb-pagination>
            </div>
          </div>

          <div
            *ngIf="showTable && (!tableData || tableData.length === 0)"
            class="text-center text-muted"
          >
            No data available for the selected Date and Department, as no
            production planning was scheduled.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #templatepdf role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">{{ action }}</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click'); cancel()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div class="example-container">
      <ul
        ngbNav
        #justifiednav="ngbNav"
        [activeId]="1"
        class="nav-pills nav-justified"
      >
        <li (click)="directExpo()" [ngbNavItem]="1">
          <a ngbNavLink>
            <h6 class="">Direct Export</h6>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="directExport"></ng-template>
          </ng-template>
        </li>
        <li (click)="mailexport()" [ngbNavItem]="2">
          <a ngbNavLink>
            <h6 class="">Export via Email</h6>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="mailExport"></ng-template>
          </ng-template>
        </li>
      </ul>
      &nbsp;&nbsp;
      <div [ngbNavOutlet]="justifiednav"></div>
      <div class="text-right mt-3">
        <button
          *ngIf="!exportViaMail"
          type="submit"
          class="btn btn-info round waves-effect headr"
          (click)="modal('Cross click'); download()"
        >
          Export
        </button>
        <button
          *ngIf="exportViaMail"
          type="submit"
          class="btn btn-info round waves-effect headr"
          (click)="modal('Cross click'); download()"
          [disabled]="!mailform.get('email').value"
        >
          Export
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #directExport>
  <form>
    <div>
      <p>Select the file type you would like to export</p>
    </div>
    <span
      class="pdf"
      [ngStyle]="{ 'background-color': pdfBool ? '#C4A484' : null }"
      ><i class="fas fa-file-pdf" (click)="pdf()"> PDF </i></span
    >&nbsp;&nbsp;
    <span
      class="csv"
      [ngStyle]="{ 'background-color': csvBool ? '#90EE90' : null }"
      ><i class="fas fa-file-csv" (click)="csv()"> CSV </i></span
    >
    &nbsp;&nbsp;
  </form>
</ng-template>

<ng-template #mailExport>
  <div>
    <p>Select the file type you would like to export</p>
  </div>
  <span
    class="pdf"
    [ngStyle]="{ 'background-color': pdfBool ? '#C4A484' : null }"
    ><i class="fas fa-file-pdf" (click)="pdf()"> PDF </i></span
  >&nbsp;&nbsp;
  <span
    class="csv"
    [ngStyle]="{ 'background-color': csvBool ? '#90EE90' : null }"
    ><i class="fas fa-file-csv" (click)="csv()"> CSV </i></span
  >&nbsp;&nbsp;
  <div>
    <form [formGroup]="mailform">
      <div class="form-group col-md-8">
        &nbsp;&nbsp;
        <input
          class="form-control"
          id="email"
          placeholder="user@gmail.com"
          formControlName="email"
          required
          [ngClass]="{ 'is-invalid': isEmailInvalid() }"
        />
        <div *ngIf="isEmailInvalid()">
          <span *ngIf="email?.hasError('required')" style="color: red"
            >Email is required</span
          >
          <span *ngIf="email?.hasError('email')" style="color: red"
            >Invalid email address</span
          >
        </div>
      </div>
    </form>
  </div>
</ng-template>